// extracted by mini-css-extract-plugin
module.exports = {"list":"RadioGroup_list__2iBW7","item":"RadioGroup_item__3aTl1"};